$(document).ready(function(){

	// -- Slick Banners init --
	var slickBanners = $('.slick--banners');
	var slickBannersSettings = {
		autoplay: true,
  	autoplaySpeed: 6000,
		arrows: false,
		dots: false
	};
	slickBanners.slick(slickBannersSettings);

	// -- Slick Gallery init --
	var slickGallery = $('.slick--gallery');
	var slickGallerySettings = {
		arrows: false,
		dots: false
	};
	slickGallery.on('init', function(event, slick){
	  updateGalleryImageTitle($(this));
	});
	slickGallery.on('beforeChange', function(event, slick){
		hideGalleryImageTitle($(this));
	});
	slickGallery.on('afterChange', function(event, slick){
		updateGalleryImageTitle($(this));
	});
	slickGallery.slick(slickGallerySettings);

  // -- Slick Gallery Nav --
  $('.gallery__navigation .prev').on('click',function(){
  	$(this).parents('.blockGallery').find('.slick--gallery').slick('slickPrev');
  });
 
  $('.gallery__navigation .next').on('click',function(){
  	$(this).parents('.blockGallery').find('.slick--gallery').slick('slickNext');
  });


  // -- Slick Testimonials Init --
	var slickTestimonials = $('.slick--testimonials');
	var slickTestimonialsSettings = {
		arrows: false,
		dots: false,
		slidesToShow: 3,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	      }
	    }
	  ]
	};
	slickTestimonials.slick(slickTestimonialsSettings);
  
  // -- Slick Testimonials Nav --
  $('.testimonial__navigation .prev').on('click',function(){
  	$(this).parents('.slider__wrapper').find('.slick--testimonials').slick('slickPrev');
  });
 
  $('.testimonial__navigation .next').on('click',function(){
  	$(this).parents('.slider__wrapper').find('.slick--testimonials').slick('slickNext');
  });

  // -- Functions --
  function hideGalleryImageTitle($this){
	  var galleryImageTitle = $this.find('.slick-current figcaption').attr('data-galleryImageTitle');
	  $this.parents('.blockGallery').find('.galleryImageTitle').animate({'opacity':0});
  }
  function updateGalleryImageTitle($this){
	  var galleryImageTitle = $this.find('.slick-current figcaption').attr('data-galleryImageTitle');
	  $this.parents('.blockGallery').find('.galleryImageTitle').text(galleryImageTitle).animate({'opacity':1});
  }

});